import React, {useContext} from "react";
import "./WorkExperience.scss";
import ExperienceCard from "../../components/experienceCard/ExperienceCard";
import {workExperiences} from "../../portfolio";
import {Fade} from "react-reveal";
import StyleContext from "../../contexts/StyleContext";

export default function WorkExperience() {
  const {isDark} = useContext(StyleContext);

  if (!workExperiences.display) return null;

  return (
    <Fade bottom duration={800} distance="20px">
      <section className={isDark ? "dark-mode main experience-section" : "main experience-section"} id="experience">
        <div className="editorial-heading">
          <span>02 / EXPERIENCE</span>
          <h2>Work</h2>
        </div>

        <div className="experience-cards-div">
          {workExperiences.experience.map((card, i) => (
            <ExperienceCard
              key={i}
              isDark={isDark}
              index={i}
              cardInfo={{
                company: card.company,
                desc: card.desc,
                date: card.date,
                companylogo: card.companylogo,
                role: card.role,
                descBullets: card.descBullets
              }}
            />
          ))}
        </div>
      </section>
    </Fade>
  );
}
